// Copyright (c) 2026, Ojas Landge
// All rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are met:
//
//     * Redistributions of source code must retain the above copyright notice,
//       this list of conditions and the following disclaimer.
//     * Redistributions in binary form must reproduce the above copyright
//       notice, this list of conditions and the following disclaimer in the
//       documentation and/or other materials provided with the distribution.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
// AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
// ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
// LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
// CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
// SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
// INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
// CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
// ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
// POSSIBILITY OF SUCH DAMAGE.

import * as monaco from 'monaco-editor';

function definition(): monaco.languages.IMonarchLanguage {
    return {
        // Set defaultToken to invalid to see what you do not tokenize yet
        defaultToken: 'invalid',

        keywords: [
            'circuit',
            'backend_circuit',
            'test',
            'test_args',
            'schematic',
            'none',
            'repeater',
            'torch',
            'comparator',
            'lamp',
            'button',
            'lever',
            'pressure_plate',
            'trapdoor',
            'wire',
            'constant',
            'note_block',
            'harp',
            'basedrum',
            'snare',
            'hat',
            'bass',
            'flute',
            'bell',
            'guitar',
            'chime',
            'xylophone',
            'iron_xylophone',
            'cow_bell',
            'didgeridoo',
            'bit',
            'banjo',
            'pling',
            'true',
            'false',
            'compare',
            'subtract',
        ],

        tokenizer: {
            root: [
                {include: '@whitespace'},

                // identifiers and keywords
                [
                    /[a-z_$][\w$]*/,
                    {
                        cases: {
                            '@keywords': 'keyword',
                            '@default': 'invalid',
                        },
                    },
                ],
                [/[@%]\w*/, 'variable.name'],

                // numbers
                [/\d+/, 'number'],

                // delimiters and operators
                [/[{}()[\]]/, '@brackets'],
                [/=/, 'operator'],
                [/[,:]/, 'delimiter'],
            ],

            whitespace: [
                [/\s+/, 'white'],
                [/(^#.*$)/, 'comment'],
            ],
        },
    };
}

const config: monaco.languages.LanguageConfiguration = {
    comments: {
        lineComment: '#',
    },
    autoClosingPairs: [
        {open: '{', close: '}'},
        {open: '[', close: ']'},
        {open: '(', close: ')'},
        {open: '"', close: '"'},
    ],
    surroundingPairs: [
        {open: '{', close: '}'},
        {open: '[', close: ']'},
        {open: '(', close: ')'},
        {open: '"', close: '"'},
    ],
};

monaco.languages.register({id: 'mchprs-ril'});
monaco.languages.setMonarchTokensProvider('mchprs-ril', definition());
monaco.languages.setLanguageConfiguration('mchprs-ril', config);
